/* me-rodape-bandeiras 02/10/2026: a newsletter do rodapé (bloco email-signup do Horizon) não traz contact[tags];
   sem ele o intercetor do pop-up (me-newsletter-popup) não a apanha e o envio ia para a Shopify (/challenge).
   Acrescenta o campo oculto para o envio seguir pelo pop-up → portes.myessenza.eu/newsletter. */
(function () {
  function marcar() {
    document.querySelectorAll('footer form.email-signup__form').forEach(function (f) {
      if (f.querySelector('input[name="contact[tags]"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'contact[tags]'; i.value = 'newsletter,rodape';
      f.appendChild(i);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', marcar); else marcar();
})();
